import { memo } from "react";
import { IconFromSet } from "./IconFromSet";

/**
 * The icon of a dashboard info page. `image_url` holds the icon picker value as a JSON string;
 * nothing renders when it is empty or cannot be parsed.
 */
export const InfoPageIcon = memo(
  ({ image_url }: { image_url?: string | null }) => {
    if (!image_url) {
      return null;
    }

    let parsedImage = null;
    try {
      parsedImage = JSON.parse(image_url);
    } catch (error) {
      console.error("Failed to parse image_url:", error);
    }
    let icon = null;
    if (typeof parsedImage === "object") {
      icon = parsedImage;
    }

    if (!icon) {
      return null;
    }

    return <IconFromSet icon={icon} size={6} color={"#6b7280"} />;
  }
);
